import {BaseContainerModel} from '../base-container.model';
import {bl_asv_consultation_request_line_RowClass} from '../../dbschema';

export class AsvConsultationRequestLineModel extends BaseContainerModel {
    bl_asv_consultation_request_line: bl_asv_consultation_request_line_RowClass = new bl_asv_consultation_request_line_RowClass();
}
